import type { QueryClient } from "@tanstack/react-query";
import type { BuddyRelationship } from "./relationship";

export const buddyRelationshipKeys = {
  all: ["buddy-relationships"] as const,
  user: (userId: string) => ["buddy-relationships", "user", userId] as const,
};

export function setBuddyRelationship(
  client: QueryClient,
  userId: string,
  relationship: BuddyRelationship,
) {
  void client.cancelQueries({ queryKey: buddyRelationshipKeys.user(userId) });
  client.setQueryData(buddyRelationshipKeys.user(userId), relationship);
}

export function invalidateBuddyRelationships(
  client: QueryClient,
  userId?: string,
) {
  void client.invalidateQueries({
    queryKey: userId
      ? buddyRelationshipKeys.user(userId)
      : buddyRelationshipKeys.all,
  });
  void client.invalidateQueries({
    queryKey: userId
      ? ["public-profile-actions", userId]
      : ["public-profile-actions"],
  });
}
